import {Component, OnInit} from '@angular/core';
import {ExamesDispositivosService} from "./exames-dispositivos.service";
import {ExamesDispositivosModel} from "./exames-dispositivos.model";
import {Global} from "../../global";
import {Components} from "../../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../../funcoes";
import {LoginService} from "../../login/login.service";

declare var swal: any;

@Component({
  selector: 'app-exames-dispositivos',
  templateUrl: './exames-dispositivos.component.html'
})
export class ExamesDispositivosComponent extends Components implements OnInit {

  dispositivos: ExamesDispositivosModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    private examesDispositivosService: ExamesDispositivosService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for (let i in data.privilegios) {
        if (data.privilegios[i].acao && data.privilegios[i].acao[0] && (data.privilegios[i].acao[0].url == 'exames' || data.privilegios[i].id_acao == '33')) {
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.examesDispositivosService.getPaginacao(1, this.itensPorPagina)
      .subscribe(data => {
        this.dispositivos = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.dispositivos);
        }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

  delete(dispositivo) {
    let dispositivos = this.dispositivos;
    let examesDispositivosService = this.examesDispositivosService;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarDispositivo') + ': ' + dispositivo.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      () => {
        if (this.global.debug == true) {
          console.log(dispositivos);
        }

        let index = dispositivos.indexOf(dispositivo);
        dispositivos.splice(index, 1);

        examesDispositivosService.apagar(dispositivo.id)
          .subscribe(res => {
              this.dispositivos = dispositivos;
            },
            err => {
              dispositivos.splice(index, 0, dispositivo);
              this.dispositivos = dispositivos;
              this.func.showErro(err.json());
            });
      });
  }

  getPage(pagina) {
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.examesDispositivosService.getPaginacao(pagina, this.itensPorPagina)
      .subscribe(data => {
        this.dispositivos = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/exames/dispositivos/exames-dispositivos.component.ts